import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const MasterDataTabs = ({ activeTab, onTabChange, onAddNew }) => {
  const tabs = [
    {
      id: 'digital-print-operators',
      label: 'Digital Print Operators',
      icon: 'Printer',
      count: 12
    },
    {
      id: 'cutting-specialists',
      label: 'Cutting Specialists',
      icon: 'Scissors',
      count: 8
    },
    {
      id: 'raw-material-suppliers',
      label: 'Raw Material Suppliers',
      icon: 'Truck',
      count: 15
    },
    {
      id: 'clients',
      label: 'Clients',
      icon: 'Users',
      count: 24
    },
    {
      id: 'general-parties',
      label: 'General Parties',
      icon: 'Building',
      count: 18
    },
    {
      id: 'purchase-invoices',
      label: 'Purchase Invoices',
      icon: 'Receipt',
      count: 8
    }
  ];

  return (
    <div className="bg-card border border-border rounded-lg">
      {/* Tab Headers */}
      <div className="border-b border-border">
        <div className="flex flex-wrap items-center justify-between p-4">
          <div className="flex flex-wrap gap-1">
            {tabs.map((tab) => (
              <Button
                key={tab.id}
                variant={activeTab === tab.id ? "default" : "ghost"}
                size="sm"
                onClick={() => onTabChange(tab.id)}
                className="flex items-center space-x-2 px-3 py-2"
              >
                <Icon name={tab.icon} size={16} />
                <span className="hidden sm:inline">{tab.label}</span>
                <span className="sm:hidden">{tab.label.split(' ')[0]}</span>
                <span className="bg-muted text-muted-foreground px-1.5 py-0.5 rounded-full text-xs">
                  {tab.count}
                </span>
              </Button>
            ))}
          </div>
          
          <Button
            variant="default"
            size="sm"
            onClick={() => onAddNew(activeTab)}
            iconName="Plus"
            iconPosition="left"
            iconSize={16}
            className="mt-2 sm:mt-0"
          >
            Add New
          </Button>
        </div>
      </div>

      {/* Tab Content Area */}
      <div className="p-4">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center space-x-2">
            <Icon 
              name={tabs.find(tab => tab.id === activeTab)?.icon || 'Database'} 
              size={20} 
              className="text-primary" 
            />
            <h2 className="text-lg font-semibold text-foreground">
              {tabs.find(tab => tab.id === activeTab)?.label || 'Master Data'}
            </h2>
          </div>
          
          <div className="flex items-center space-x-2">
            <Button
              variant="outline"
              size="sm"
              iconName="Download"
              iconPosition="left"
              iconSize={16}
            >
              Export
            </Button>
            <Button
              variant="outline"
              size="sm"
              iconName="Upload"
              iconPosition="left"
              iconSize={16}
            >
              Import
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MasterDataTabs;